import { capturePipelinesExceptionWithTags } from 'src/components/pipelines/utils/sentry';
import { request } from 'src/utils/http-request';

export async function fetchData(
  url: string,
  exceptionSegment: string
): Promise<any> {
  try {
    const resp = await request(url);
    return resp;
  } catch (e) {
    capturePipelinesExceptionWithTags(e, {
      segment: exceptionSegment,
    });
    throw e;
  }
}
